import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { VoucherBookingCountdown } from '@products/models/booking.model';

export const BookingCountdownActions = createActionGroup({
  source: 'Booking Countdown',
  events: {
    'Set product booking countdown': props<{ releaseInMinutes: number }>(),
    'Set voucher  product booking countdown': (voucherBookingCountdowns: VoucherBookingCountdown[]) => ({
      voucherBookingCountdowns
    }),
    'Remove voucher  product booking countdown': (
      voucherBookingCountdowns: VoucherBookingCountdown[],
      releaseInMinutes: number
    ) => ({
      voucherBookingCountdowns,
      releaseInMinutes
    }),
    'Remove product booking countdowns': emptyProps()
  }
});
